export default __webpack_public_path__ + "static/media/wallstreet_logo.843e11e6.png";